// Error message mapper for different HTTP status codes
const errorMessageMapper = (statusCode) => {
  // 4xx Client Errors
  if (statusCode >= 400 && statusCode < 500) {
    switch (statusCode) {
      case 400:
        return 'Bad request. Please check your input.'
      case 401:
        return 'Unauthorized. Please log in again.'
      case 403:
        return 'You do not have permission to perform this action.'
      case 404:
        return 'The requested resource was not found.'
      case 409:
        return 'Conflict. This resource already exists.'
      case 422:
        return 'Validation error. Please check your input.'
      case 429:
        return 'Too many requests. Please try again later.'
      default:
        return 'An error occurred. Please try again.'
    }
  }

  // 5xx Server Errors
  if (statusCode >= 500 && statusCode < 600) {
    return 'Something went wrong on our end.'
  }

  // Network errors (no status code)
  if (!statusCode) {
    return 'Network error. Please check your connection.'
  }

  // Default fallback
  return 'An unexpected error occurred.'
}

export default errorMessageMapper
